import styles from "../../../../styles/beneficios/steps/BenefitTypeSelectStepOld.module.scss";

import classNames from "classnames/bind";
import { If } from "../../../components/control-statements";
import { Icon } from "../../../components/core/Icon";
import { Label } from "../../../components/Label";
import { Select } from "../../../components/Select";
import { useEffect, useState } from "react";
import { OlgaEnvironmentsAPI } from "../../../../providers/OlgaEnvironmentsAPI";
import { Hairline } from "../../../components/Hairline";
import { Checkbox } from "@components";
import { Environment } from "shared/core/Environment";
const css = classNames.bind(styles);

const benefitTypes = {
  CASH_DISCOUNT: "CASH_DISCOUNT",
  PERCENTAGE_DISCOUNT: "PERCENTAGE_DISCOUNT",
  FREE_DELIVERY: "FREE_DELIVERY",
  CASHBACK: "CASHBACK",
  PRODUCT_DISCOUNT: "PRODUCT_DISCOUNT",
  PRODUCT_CASH_DISCOUNT: "PRODUCT_CASH_DISCOUNT",
};

export const BenefitSelectTypeStepOld = ({
  benefit,
  onChange,
  programByPoint,
}) => {
  const [folders, setFolders] = useState([]);

  const allowsTemplate = Environment.id === 51 || Environment.id === 66;

  useEffect(() => {
    loadFolders();
  }, []);

  const selectBenefit = (type) => {
    onChange({ ...benefit, type });
  };

  const selectFolder = (folder) => {
    onChange({ ...benefit, folder: folder === -1 ? null : folder });
  };

  const toggleTemplate = () => {
    const newValue = !benefit?.template;
    onChange({
      ...benefit,
      template: newValue,
      single_use: newValue ? 4 : null,
    });
  };

  const loadFolders = async () => {
    const environmentConfigurations = (
      await OlgaEnvironmentsAPI.getConfigurations()
    ).getData({});
    const couponFolders = environmentConfigurations?.coupon_folders || [];
    setFolders(couponFolders);
  };

  const folderOptions = folders.map((folder) => ({
    label: folder.name,
    value: folder.id,
  }));

  return (
    <>
      <Label>Determine o benefício</Label>

      <div className={styles.benefits}>
        <div
          className={css({
            option: true,
            active: benefit.type === benefitTypes.CASH_DISCOUNT,
          })}
          onClick={() => selectBenefit(benefitTypes.CASH_DISCOUNT)}
        >
          <If cond={benefit.type !== benefitTypes.CASH_DISCOUNT}>
            <Icon name="sack-dollar" light />
          </If>
          <If cond={benefit.type === benefitTypes.CASH_DISCOUNT}>
            <Icon name="check" />
          </If>
          <p>Desconto em R$</p>
        </div>

        <div
          className={css({
            option: true,
            active: benefit.type === benefitTypes.PERCENTAGE_DISCOUNT,
          })}
          onClick={() => selectBenefit(benefitTypes.PERCENTAGE_DISCOUNT)}
        >
          <If cond={benefit.type !== benefitTypes.PERCENTAGE_DISCOUNT}>
            <Icon name="percent" light />
          </If>
          <If cond={benefit.type === benefitTypes.PERCENTAGE_DISCOUNT}>
            <Icon name="check" />
          </If>
          <p>Desconto em %</p>
        </div>

        <div
          className={css({
            option: true,
            active: benefit.type === benefitTypes.FREE_DELIVERY,
          })}
          onClick={() => selectBenefit(benefitTypes.FREE_DELIVERY)}
        >
          <If cond={benefit.type !== benefitTypes.FREE_DELIVERY}>
            <Icon name="motorcycle" light />
          </If>
          <If cond={benefit.type === benefitTypes.FREE_DELIVERY}>
            <Icon name="check" />
          </If>
          <p>Entrega grátis</p>
        </div>

        <If cond={!programByPoint}>
          <div
            className={css({
              option: true,
              active: benefit.type === benefitTypes.CASHBACK,
            })}
            onClick={() => selectBenefit(benefitTypes.CASHBACK)}
          >
            <If cond={benefit.type !== benefitTypes.CASHBACK}>
              <Icon name="hand-holding-dollar" light />
            </If>
            <If cond={benefit.type === benefitTypes.CASHBACK}>
              <Icon name="check" />
            </If>
            <p>Cashback</p>
          </div>
        </If>

        <If cond={programByPoint}>
          <div
            className={css({
              option: true,
              active: benefit.type === benefitTypes.CASHBACK,
            })}
            onClick={() => selectBenefit(benefitTypes.CASHBACK)}
          >
            <If cond={benefit.type !== benefitTypes.CASHBACK}>
              <Icon name="circle-1" light />
            </If>
            <If cond={benefit.type === benefitTypes.CASHBACK}>
              <Icon name="check" />
            </If>
            <p>Pontos</p>
          </div>
        </If>

        <div
          className={css({
            option: true,
            active: benefit.type === benefitTypes.PRODUCT_DISCOUNT,
          })}
          onClick={() => selectBenefit(benefitTypes.PRODUCT_DISCOUNT)}
        >
          <If cond={benefit.type !== benefitTypes.PRODUCT_DISCOUNT}>
            <Icon name="pot-food" light />
          </If>
          <If cond={benefit.type === benefitTypes.PRODUCT_DISCOUNT}>
            <Icon name="check" />
          </If>
          <p>Produto (desconto em %)</p>
        </div>

        {(Environment.id === 66 || Environment.id === 8) && (
          <div
            className={css({
              option: true,
              active: benefit.type === benefitTypes.PRODUCT_CASH_DISCOUNT,
            })}
            onClick={() => selectBenefit(benefitTypes.PRODUCT_CASH_DISCOUNT)}
          >
            <If cond={benefit.type !== benefitTypes.PRODUCT_CASH_DISCOUNT}>
              <Icon name="pot-food" light />
            </If>
            <If cond={benefit.type === benefitTypes.PRODUCT_CASH_DISCOUNT}>
              <Icon name="check" />
            </If>
            <p>Produto (desconto em R$)</p>
          </div>
        )}
      </div>

      <Hairline />

      <Label text={"Deseja agrupar este benefício em uma pasta?"} />
      <Select
        label="Pasta"
        className="w-100"
        value={benefit?.folder}
        options={[{ label: "Selecione", value: -1 }].concat(folderOptions)}
        onChange={(e) => selectFolder(e.target.value)}
      />

      {allowsTemplate && (
        <>
          <Hairline />

          <Checkbox
            checked={benefit?.template}
            onChange={() => toggleTemplate()}
          >
            Utilizar como um modelo?
          </Checkbox>
        </>
      )}
    </>
  );
};
